import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                {/* <span class="glf-button" data-glf-cuid="8c23f724-a2a8-44d5-8807-f7dbbd5ff005" data-glf-ruid="077ee8b1-d71c-4f3b-9d3d-e669532b3035" >Order Now</span> */}
                <a
                  href="https://www.toasttab.com/k-l-delicatessen-7601-37th-ave"
                  target="_blank"
                  rel="noopener noreferrer" 
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Order Online
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
